import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { deleteInvoiceByID, getAllInvoice } from "../../api/ReportApi";
import ToastFile from "../../utils/ToastFile";
import { MdDelete } from "react-icons/md";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";

const Invoice = () => {
  const [dates, setDates] = useState({ start: null, end: null });
  const [invoiceData, setInvoiceData] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const fetched = useRef(false);
  const [deleteModal, setDeleteModal] = useState(false)
    const [deleteIndex, setDeleteIndex] = useState(0);
    const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
     if (fetched.current) return;
    fetched.current = true;
    getInvoice();
  }, []);

  const handleDateChange = (e) => {
    setDates({ ...dates, [e.target.name]: e.target.value });
  };

  const handleGenerate = async () => {
    let startDate = dates.start
      ? moment(new Date(dates.start)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    let endDate = dates?.end
      ? moment(new Date(dates?.end)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    navigate("/generateinvoice", {
      replace: true,
      state: { startDate, endDate },
    });
  };

  const getInvoice = () => {
    setIsloading(true);
    getAllInvoice(user.id)
      .then((res) => {
        if (res.status === 200) {
          setInvoiceData(res?.data?.data?.invoices);
        }
      })
      .catch((err) => {
        console.error("Error fetching invoices:", err);
      })
      .finally(()=>{
        setIsloading(false)
      })
  };

  const deleteInvoice = () => {
    deleteInvoiceByID(invoiceData[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Invoice deleted", "deleted");
          getInvoice();
        } else {
          ToastFile("Failed to delete invoice", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting invoice:", err);
        ToastFile("Error deleting invoice", "error");
      })
      .finally(()=>{
        setDeleteIndex(0)
        setDeleteModal(false)
      })
  };

 const decimalNumber = (num) => {
    return isNaN(num) ? 0 : Number(num).toFixed(2); 
  }

  return (
    <Layout>
      <DeleteModel showModal={deleteModal} setShowModal={setDeleteModal} onYes={deleteInvoice}/>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Invoices</h3>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <Form>
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="start"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    value={dates.start}
                    onChange={handleDateChange}
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label>To</Form.Label>
                  <Form.Control
                    type="date"
                    name="end"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    value={dates.end}
                    onChange={handleDateChange}
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                <Button
                  variant="success"
                  onClick={handleGenerate}
                  className="w-100 d-flex align-items-center justify-content-center gap-2"
                >
                  Generate Invoice
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div>
        <Table bordered responsive size="sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th>Invoice No</th>
              <th>Date of Invoice</th>
              <th>Company Name</th>
              <th>Date Range</th>
              <th>Total Amount</th>
              <th>GST Amount</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
           {isLoading ? <tbody>
              <tr>
                <td colSpan="7">
                  <Loader/>
                </td>
              </tr>
            </tbody>
            :
          <tbody>
            {invoiceData.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No data
                </td>
              </tr>
            ) : (
              invoiceData?.map((inv, idx) => (
                <tr key={idx}>
                  <td>{inv.invoiceNumber}</td>
                  <td style={{ textAlign: "center" }}>
                    {moment(inv.date).format("DD/MM/YYYY")}
                  </td>
                  <td>{inv.companyName}</td>
                  <td style={{ textAlign: "center" }}>
                    {moment(inv.startDate).format("DD/MM/YYYY")} - {moment(inv.endDate).format("DD/MM/YYYY")}
                  </td>
                  <td style={{ textAlign: "end" }}>{decimalNumber(inv.totalAmount)}</td>
                  <td style={{ textAlign: "end" }}>{inv.GST}</td>
                  <td className="text-nowrap">
                    <div className="d-flex justify-content-center gap-2">
                      {/* <button
                        className="btn btn-sm btn-outline-primary border-0"
                        onClick={() => openViewModal(idx)}
                        title="View"
                      >
                        <FaEye size={16} />
                      </button> */}
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>}
        </Table>
      </div>
    </Layout>
  );
};

export default Invoice;
